import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  FONT_PROXIMA_13,
  FONT_WEIGHT_PROXIMA_REGULAR,
  FONT_WEIGHT_PROXIMA_SEMIBOLD,
} from 'styles/FontConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import {ChipSize} from 'ui-library/chips/Chip';
import ProcedureChip from 'ui-library/chips/ProcedureChip';
import EditableTextField, {TextFieldType} from 'ui-library/inputs/EditableTextField';
import {SettingsLabel} from 'ui-library/SettingsField';
import * as DateUtil from 'util/DateUtil';

interface MetadataTabLayoutProps {
  name: string;
  descriptionEditor: React.ReactNode;
  procedureId: string;
  flowchartVersionId: string;
  createdAt?: string;
}

export const MetadataTabLayout = ({
  name,
  descriptionEditor,
  procedureId,
  flowchartVersionId,
  createdAt,
}: MetadataTabLayoutProps): JSX.Element => (
  <div className={css(styles.container)}>
    <div className={css(styles.nameStyle)}>
      <div className={css(styles.nameTitle)}>
        <SettingsLabel isRequired={false} label="Name" name="name" withBottomMargin={false} />
      </div>
      <EditableTextField isDisabled={true} requestChange={() => {}} value={name} type={TextFieldType.TEXT} />
    </div>
    <div className={css(styles.descriptionStyle)}>{descriptionEditor}</div>
    <div className={css(styles.row)}>
      <FormGroup>
        <div className={css(styles.label)}>Recipe</div>
        <div className={css(styles.value)}>
          <ProcedureChip id={procedureId} flowchartVersionId={flowchartVersionId} size={ChipSize.MINI} />
        </div>
      </FormGroup>
      {createdAt != null && (
        <>
          <div className={css(styles.spacer)} />
          <FormGroup>
            <div className={css(styles.label)}>Created</div>
            <div className={css(styles.value)}>{DateUtil.readableTime(createdAt, {showTime: true})}</div>
          </FormGroup>
        </>
      )}
    </div>
  </div>
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.WHITE,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  nameStyle: {
    display: 'grid',
    width: '100%',
    maxWidth: '600px',
    paddingTop: 16,
    paddingBottom: 16,
    alignItems: 'flex-start',
  },
  descriptionStyle: {display: 'block', width: '100%', maxWidth: '600px', marginBottom: -10},
  row: {display: 'flex', alignItems: 'center', width: '100%', maxWidth: '600px'},
  label: {...FONT_PROXIMA_13, fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD, color: Color.BLACK, paddingTop: 6},
  value: {
    ...FONT_PROXIMA_13,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: Color.BLACK,
    paddingTop: 6,
    display: 'flex',
    alignItems: 'center',
  },
  spacer: {width: 125},
  nameTitle: {marginLeft: -10},
});
